/**
 * Canonical pool registry. Updated by the deploy scripts in `apps/contracts/scripts`.
 *
 * Keys: `<assetId>-<amount>` — e.g. `ton-1`, `ton-10`, `jetton:EQ...-100`.
 *
 * Addresses left blank until the contracts are actually deployed.
 */
export const deployments = {
    testnet: {
        pools: {
            "ton-0.1": {
                address: "EQDAIju_M7gaizur3BxXdS-R7xugcnrJLZ8TOOk1vPGq63r9",
                asset: "ton",
                amount: "0.1",
                denomination: "100000000",
                deployedSeqno: 98,
            },
            "ton-1": {
                address: "",
                asset: "ton",
                amount: "1",
                denomination: "1000000000",
                deployedSeqno: 0,
            },
            "ton-10": {
                address: "",
                asset: "ton",
                amount: "10",
                denomination: "10000000000",
                deployedSeqno: 0,
            },
        },
    },
    mainnet: {
        pools: {
            "ton-0.1": {
                address: "EQCMtkwWpfydYJYYFrtwm5lxtnC1HXMyYiKalG_DozG0MMIW",
                asset: "ton",
                amount: "0.1",
                denomination: "100000000",
                deployedSeqno: 1,
            },
            "ton-1": {
                address: "EQDs6oeBKtlDDgSgJ4cWlmVfiHgw_vHkLViPhVQuP_9GD84K",
                asset: "ton",
                amount: "1",
                denomination: "1000000000",
                deployedSeqno: 2,
            },
            "ton-10": {
                address: "EQCRPu50m7CKn75bmldKBZ8Td5fNSDbfpIGXl9ttkx-fF5mz",
                asset: "ton",
                amount: "10",
                denomination: "10000000000",
                deployedSeqno: 3,
            },
            "ton-100": {
                address: "EQCNo7zRoqZDBXRoFFzmsKpm_tiV6Bcy-UYZc3now0raAjzH",
                asset: "ton",
                amount: "100",
                denomination: "100000000000",
                deployedSeqno: 4,
            },
        },
    },
};
export function poolKey(asset, amount) {
    return `${asset}-${amount}`;
}
export function getPool(network, asset, amount) {
    return deployments[network]?.pools[poolKey(asset, amount)];
}
export function listAmounts(network, asset) {
    const pools = deployments[network]?.pools ?? {};
    return Object.values(pools)
        .filter((p) => p.asset === asset)
        .map((p) => p.amount)
        .sort((a, b) => Number(a) - Number(b));
}
export function listAssets(network) {
    const pools = deployments[network]?.pools ?? {};
    return Array.from(new Set(Object.values(pools).map((p) => p.asset))).sort();
}
export function isDeployed(p) {
    return p.address.length > 0;
}
//# sourceMappingURL=deployments.js.map